module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/img/page-two-a_a@2x.66169e9c.jpg";